import { NotesFieldsEdit } from '../../../../types/form-types'
import '../../../../styles/4-layout/_note-container.scss'
import { formatDate } from '@msaf/core-common'
import { Button, ButtonsContainer, Card, FormField, GroupContainer, Tag } from '@msaf/core-react'

interface NoteWrapperProps {
  note: Partial<NotesFieldsEdit> | undefined
  isLoading: boolean
  editMode: boolean
  removeField?: (index: number) => void
  idx: number
  addEditNote?: (note: object, idx: number) => void
}

export default function Note({ note, isLoading, editMode, removeField, idx, addEditNote }: NoteWrapperProps) {
  let createdBy = ''
  if (note!.createdBy) {
    createdBy = note!.createdBy
  }

  const removeNoteHandler = () => {
    if (removeField) {
      removeField(idx)
    }
  }
  const addEditNoteHandler = () => {
    if (note && addEditNote) {
      addEditNote(note, idx)
    }
  }

  return (
    <div className='c-note-group-container'>
      <div className='c-note-meta-container'>
        <FormField labelId='note' label=''>
          {createdBy}
        </FormField>
        <FormField labelId='createdTimestamp' label=''>
          {`${formatDate(note?.createdTimestamp) ?? ''}`}
        </FormField>
      </div>
      <div className='c-note-content-container'>
        <Card isFullWidth={editMode}>
          <div className='c-note-content'>
            <p className='c-note'>{note?.note ?? ''}</p>
            <div className='c-is-public'>
              <GroupContainer horizontalAlignment='right'>
                {note!.isPublic ? <Tag label={'Public'}></Tag> : <Tag tagStyle='disabled' label={'Private'}></Tag>}
              </GroupContainer>
            </div>
            {editMode && note!.isEditable && (
              <ButtonsContainer containerStyle='left'>
                <Button buttonStyle='text-action' label='Edit' onClick={addEditNoteHandler} />
                <Button buttonStyle='text-action' label='Delete' onClick={removeNoteHandler} />
              </ButtonsContainer>
            )}
          </div>
        </Card>
      </div>
    </div>
  )
}
